import React from 'react';
import { motion } from 'framer-motion';
export function DestinationGallery() {
  const images = [{
    src: 'https://cdn.rawproductionsgmbh.de/shootingtrip/portugalmai2026/portugalmai2026-2.jpg',
    span: 'col-span-2 row-span-2',
    label: 'Algarve Coast'
  }, {
    src: 'https://cdn.rawproductionsgmbh.de/shootingtrip/portugalmai2026/portugalmai2026-5.jpg',
    span: 'col-span-1 row-span-1',
    label: 'Golden Hour'
  }, {
    src: 'https://cdn.rawproductionsgmbh.de/shootingtrip/portugalmai2026/portugalmai2026-8.jpg',
    span: 'col-span-1 row-span-2',
    label: 'Editorial'
  }, {
    src: 'https://cdn.rawproductionsgmbh.de/shootingtrip/portugalmai2026/portugalmai2026-14.jpg',
    span: 'col-span-1 row-span-1',
    label: 'Lifestyle'
  }, {
    src: 'https://cdn.rawproductionsgmbh.de/shootingtrip/portugalmai2026/portugalmai2026-18.jpg',
    span: 'col-span-2 row-span-1',
    label: 'Cliff Villa'
  }, {
    src: 'https://cdn.rawproductionsgmbh.de/shootingtrip/portugalmai2026/portugalmai2026-22.jpg',
    span: 'col-span-1 row-span-1',
    label: 'Portrait'
  }, {
    src: 'https://cdn.rawproductionsgmbh.de/shootingtrip/portugalmai2026/portugalmai2026-35.jpg',
    span: 'col-span-1 row-span-2',
    label: 'Coastline'
  }, {
    src: 'https://cdn.rawproductionsgmbh.de/shootingtrip/portugalmai2026/portugalmai2026-40.jpg',
    span: 'col-span-2 row-span-1',
    label: 'Sunset'
  }];
  return <section id="galerie" className="py-24 md:py-32 px-6 bg-white" data-id="element-194">
      <div className="max-w-7xl mx-auto" data-id="element-195">
        <div className="mb-16 flex flex-col md:flex-row md:items-end justify-between gap-6" data-id="element-196">
          <div data-id="element-197">
            <span className="block text-xs font-body tracking-[0.3em] text-brand-accent uppercase mb-4" data-id="element-198">
              Impressionen
            </span>
            <h2 className="text-4xl md:text-5xl font-heading text-[#1a1a2e]" data-id="element-199">
              Momente, die bleiben.
            </h2>
          </div>
          <p className="text-[#4a4a5a] font-light max-w-md" data-id="element-200">
            Ein Einblick in die Ästhetik und Qualität unserer vergangenen und
            kommenden Shooting-Trips.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 auto-rows-[200px] md:auto-rows-[250px]" data-id="element-201">
          {images.map((img, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className={`relative overflow-hidden rounded-xl group shadow-sm ${img.span}`} data-id="element-202">
              <div className="absolute inset-0 bg-black/5 group-hover:bg-[#1a1a2e]/50 transition-colors duration-500 z-10" data-id="element-203" />
              <img src={img.src} alt={img.label} className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-110" data-id="element-204" />
              <div className="absolute inset-0 z-20 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-205">
                <span className="font-heading text-xl text-white tracking-wide drop-shadow-lg" data-id="element-206">
                  {img.label}
                </span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}